import { gql } from '@apollo/client'

export const GET_CAMPAIGNS_BY_TAG = gql`
  query CampaignsByTag($tag: String!) {
    campaigns(first: 100, filters: { campaignTags: [$tag] }) {
      totalCount
      nodes {
        uuid
        id
        name
        status
        campaignTagList
      }
    }
  }
`
